import { LocalDate } from '@js-joda/core';

import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, DatePicker, dayValidator } from '@dreryk/react-components';

import { medicalDocumentationCreateTranslationKeys } from '../../translations';

type DateToDatePickerProps = FieldControllerProps<'dateTo', LocalDate | undefined> &
   ClassNameProp & {
      readonly dateFrom: LocalDate | undefined;
   };

export const DateToDatePicker = (props: DateToDatePickerProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
   });

   return (
      <DatePicker
         testId={props.name}
         controller={controller}
         className={props.className}
         label={medicalDocumentationCreateTranslationKeys.dateTo}
         dayValidators={[dayValidator.dayAfterToday(), dayValidator.dayBeforeReferenceDay(props.dateFrom)]}
         withNavigationArrows
      />
   );
};
